<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <h6 class="element-header">
        Detailübersicht
      </h6>

      <div class="element-box">
        <div class="d-flex justify-content-end">
          <CreateButton
              :label="$t('general.button.back')"
              :to="{ name: 'analyticsUnemployedDetailsOverviewList' }">
          </CreateButton>
        </div>

        <UnemployedDetails :unemployedData="unemployedData"/>
      </div>

      <div class="element-box"
           v-if=" currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'">
        <PrivateCoachingList
            :privateCoachingList="coachingList.privateCoachingList"/>
      </div>

      <div class="element-box"
           v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'">
        <GroupCoachingList
            :groupCoachingList="coachingList.groupCoachingList"/>
      </div>

      <div class="element-box"
           v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'">
        <SocioTherapyCoachingList
            :socioTherapyCoachingList="coachingList.socioTherapyCoachingList"/>
      </div>

      <div class="element-box"
           v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'">
        <AssistedLivingCoachingList
            :assistedLivingCoachingList="coachingList.assistedLivingCoachingList"/>
      </div>

      <div class="element-box"
           v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'">
        <CaseManagementCoachingList
            :caseManagementCoachingList="coachingList.caseManagementCoachingList"/>
      </div>

      <div class="element-box"
           v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'">
        <PrivateLearningCoachingList
            :privateLearningCoachingList="coachingList.privateLearningCoachingList"/>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import analyticsUnemployedDetailsOverviewService from '@/api/Analytics/Unemployed/DetailsOverview';
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { ErrorToast } from '@/components/VueToast';
import { piniaUserStore } from '@/store/piniaUserStore';
import AssistedLivingCoachingList
  from '@/views/App/Analytics/Unemployed/DetailOverview/Coaching/AssistedLivingCoaching/AssistedLivingCoachingList.vue';
import CaseManagementCoachingList
  from '@/views/App/Analytics/Unemployed/DetailOverview/Coaching/CaseManagementCoaching/CaseManagementCoachingList.vue';
import GroupCoachingList
  from '@/views/App/Analytics/Unemployed/DetailOverview/Coaching/GroupCoaching/GroupCoachingList.vue';
import PrivateCoachingList
  from '@/views/App/Analytics/Unemployed/DetailOverview/Coaching/PrivateCoaching/PrivateCoachingList.vue';
import PrivateLearningCoachingList
  from '@/views/App/Analytics/Unemployed/DetailOverview/Coaching/PrivateLearningCoaching/PrivateLearningCoachingList.vue';
import SocioTherapyCoachingList
  from '@/views/App/Analytics/Unemployed/DetailOverview/Coaching/SocioTherapyCoaching/SocioTherapyCoachingList.vue';
import UnemployedDetails from '@/views/App/Analytics/Unemployed/DetailOverview/Coaching/UnemployedDetails.vue';
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const piniaUserState   = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole  = piniaCurrentUser.value.roles[ 0 ];
const isLoaded         = ref(false);
const route            = useRoute();
const unemployedData   = ref({});
const coachingList     = ref([]);

async function getCoachingList() {
  try {
    const { data }       = await analyticsUnemployedDetailsOverviewService.getCoachingListForUnemployed(route.params.id);
    unemployedData.value = data.data.unemployed;
    coachingList.value   = data.data;
  } catch (error) {
    await ErrorToast('Error fetching data');
  }
}

onMounted(async () => {
  await getCoachingList();
  isLoaded.value = true;
});
</script>

<style scoped>

</style>